<template>
  <div class="horus-submit-organization-manager-view container">
    <div class="navbar">
      <div class="main-bar member">
        <img src="/static/images/narrative_icon_w.png" class="navi-logo-icon">
      </div>
    </div><!-- nav bar -->
    <div class="content">
      <h1 class="centering-title">ナラティブブック施設管理者承認</h1>
      <div class="taken-not-valid accept-form" v-if="!isTokenValid">
        <h2>施設管理者案内が無効です</h2>
        <div class="caption">
          メールのリンクURLが正しくアドレスバーに表示されているかをご確認ください。<br/>
          リンクURLが正しく入力されているにも関わらず、この画面が見えている場合は、案内が無効化されています。<br/>
          ナラティブブックのシステム管理者にお問合せください。<br/>
        </div>
      </div>
      <div v-if="isTokenValid">
        <div class="pre-process" v-if="!validationFinished" >
          <div class="message">
            {{ organizationName }}の施設管理者案内です。<br/>
            下記の手順に従って承認手続きを行ってください。<br/>
            <span>利用期限: {{ limitAtStr }}</span><br/>
            <span>メールアドレス: {{ mail }}</span>
          </div>
          <div class="accept-form">
            <h2>利用者ID(NBID)をお持ちの方</h2>
            ナラティブブックのログインに用いる利用者ID(NBID)とパスワードを入力ください。<br/>
            <div class="input-block">
              <label>利用者ID(NBID):</label>
              <input type="text" class="nbid-input" v-model="nbid" />
            </div>
            <div class="input-block">
              <label>パスワード：</label>
              <input type="password" class="password-input" v-model="password" />
            </div>
            <div class="input-block">
              <button type="button" class="admit-by-signin-btn" @click="admitBySignin">ログインして承認</button>
            </div>
          </div>
          <div class="accept-form">
            <h2>利用者ID(NBID)をお持ちでない方</h2>
            ナラティブブックの利用者IDをお持ちでない方は、下記のボタンから利用者登録を行ってください。
            <div class="input-block">
              <button type="button" class="admit-with-create-btn" @click="admitWithCreate">新規利用者登録</button>
            </div>
          </div>
        </div><!-- pre process -->
        <div class="processed" v-if="validationFinished">
          <h2>承認処理完了</h2>
          <div class="message">
            {{ organizationName }}の施設管理者の承認処理を完了しました。<br/>
            以後、あなたは{{ organizationName }}の施設管理者となります。<br/>
          </div>
          <div class="finish-controlls">
            <button type="button" class="start-btn" @click="doSignin">ログインして続行</button>
            <button type="button" class="finish-btn" @click="backToLanding">ログインせずに終了</button>
          </div>
        </div>
      </div>
    </div><!-- content -->
    <horus-footer />
  </div>
</template>

<script>
import moment from 'moment'

import {
  SigninMember
} from '@/models'
import { OrganizationManagerInvitation } from '@/api'

import HorusFooter from '@/components/common/HorusFooter.vue'
export default {
  name: 'HorusSubmitOrganizationManagerView',

  components: {
    HorusFooter
  },

  data () {
    return {
      token: '',
      organizationName: '',
      limitAt: null,
      isTokenValid: true,
      shortToken: '',
      nbid: '',
      password: '',
      mail: '',
      validationFinished: false
    }
  },

  computed: {
    limitAtStr () {
      if (this.limitAt) {
        return moment(this.limitAt).format('YYYY年MM月DD日 HH時mm分')
      } else {
        return '--------'
      }
    }
  },

  watch: {
    '$attrs': { handler: 'initToken', immediate: true }
  },

  methods: {
    initToken () {
      this.token = this.$attrs.token
      OrganizationManagerInvitation.fetchReceive({ invitationToken: this.token }).then(res => {
        this.organizationName = res.organization_name
        this.limitAt = new Date(res.limit_at)
        this.mail = res.mail
        this.isTokenValid = true
      }).catch(error => {
        console.error(error.response)
        if (error.response.status === 404) {
          this.isTokenValid = false
        }
      })
    },

    admitBySignin () {
      OrganizationManagerInvitation.admit({ token: this.token, loginID: this.nbid, password: this.password }).then(() => {
        this.validationFinished = true
      })
    },

    doSignin () {
      SigninMember.api().fetch({ loginID: this.nbid, password: this.password }).then(() => {
        const allMember = SigninMember.all()
        this.SigninMember = allMember[0]
        this.$router.push({ path: '/member_portal' })
      })
    },

    backToLanding () {
      this.$router.push({ path: '/signout' })
    },

    admitWithCreate () {
      this.$router.push({ path: '/create_user', query: { token: this.token, tokenType: 'organization_manager', mail: this.mail } })
    }
  }
}
</script>

<style lang="scss" scoped>
.horus-submit-organization-manager-view {
  height: 100%;
  overflow: auto;
  background-color: #f5f5f5;
  .content {
    min-height: calc(100% - 50px - 40px - 132px);
    padding: 20px;
    h1.centering-title {
      margin: 0 0 10px;
      text-align: center;
      font-size: 1em;
      font-weight: bold;
    }
    h2 {
      font-size: 1.1em;
      font-weight: normal;
    }
    .message {
      margin: 10px auto;
      padding: 10px 20px;
      width: 500px;
      border: 1px solid #ddd;
      background-color: #fff;
      text-align: center;
    }
    .accept-form {
      display: flex;
      flex-direction: column;
      margin: 10px;
      padding: 10px 20px;
      border: 1px solid #aaa;
      background-color: #fff;
      h2 {
        margin: 10px;
        color: #b94047;
        text-align: center;
      }
      .caption {
        margin: 10px auto;
      }
      .input-block {
        margin: 5px auto;
        label {
          display: inline-block;
          width: 150px;
          text-align: right;
        }
        input {
          font-size: 16px;
        }
        button {
          margin: 20px 0;
          padding: 3px 10px;
          border-radius: 5px;
          border: 1px solid #4cae4c;
          background-color: #4cae4c;
          color: #fff;
          font-size: 15px;
          font-weight: bold;
        }
      }
    }
    .finish-controlls {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px;
      button {
        margin: 10px 0;
        padding: 3px 10px;
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        &.start-btn {
          border: 1px solid #4cae4c;
          background-color: #4cae4c;
        }
        &.finish-btn {
          border: 1px solid #ee7800;
          background-color: #ee7800;
        }
      }
    }
    .token-failed {
      margin: 10px 20px;
      padding: 10px;
      background-color: #fff;
      border: 1px solid #b94047;
      h4 {
        margin: 5px;
        color: #b94047;
        text-align: center;
      }
    }
  }
}
</style>
